module.exports = __webpack_public_path__ + "img/rebel-fm.f833dcbd.png";